import React from 'react';

import {Cell} from 'fixed-data-table-2';
import * as ramda from 'ramda';

import {RenderedCell} from './generic';
import {NameCell} from './name';

// @ts-expect-error
function getCellData(key, row) {
    if (!row.fields) return undefined;

    // @ts-expect-error
    return ramda.has(key)(row.fields) ? row.fields[key] : undefined;
}

// @ts-expect-error
function getCellEntityId(row): string | null | undefined {
    if (!row.fields) return null;

    return row.id;
}

type Props = {
    field: string;
    rowIndex: number;
    height: number;
    width: number;
    getRow: (arg1: number) => any;
    toggleItem?: (arg1: any) => void;
    shiftSelectItem?: (arg1: any) => void;
    checkRowSelected: (entityId: string) => boolean;
    schema: any;
};

export function NutCell(props: Props) {
    const rowInfo = props.getRow(props.rowIndex);

    return (
        <Cell height={props.height} width={props.width}>
            {props.field === 'name' ? (
                <NameCell
                    isSelected={props.checkRowSelected(rowInfo.id)}
                    selection={
                        props.toggleItem && props.shiftSelectItem
                            ? {
                                  onSelect: props.toggleItem,
                                  onShiftSelect: props.shiftSelectItem,
                              }
                            : undefined
                    }
                    cellData={rowInfo}
                />
            ) : (
                <RenderedCell
                    entityId={getCellEntityId(rowInfo)}
                    cellData={getCellData(props.field, rowInfo)}
                    columnData={props.schema[props.field]}
                />
            )}
        </Cell>
    );
}
